import TranslateNew from "@translate/TranslateNew";
import { TemplateName } from '@app-types/websocket/schedule.types';

export interface ICalendarTemplate {
    name: TemplateName;
    days: boolean[];
}

export default [
    {
        name: TemplateName.CUSTOM,
        days: [],
        type: 'AlternatingResidence',
    },
    {
        name: TemplateName.ALTERNATING_WEEKS,
        days: [
            true, true, true, true, true, true, true,
            false, false, false, false, false, false, false
        ],
        type: 'AlternatingResidence',
    },
    {
        name: TemplateName.T223,
        days: [
            true, true, false, false, true, true, true,
            false, false, true, true, false, false, false
        ],
        type: 'AlternatingResidence',
    },
    {
        name: TemplateName.T3443,
        days: [
            true, true, true, false, false, false, false,
            true, true, true, true, false, false, false
        ],
        type: 'AlternatingResidence',
    },
    {
        name: TemplateName.T255,
        days: [
            true, true, false, false, true, true, true,
            true, true, false, false, false, false, false
        ],
        type: 'AlternatingResidence',
    },
    {
        name: TemplateName.T3NIGHTSPW,
        days: [
            false, false, false, false, true, true, true,
            false, false, false, false, true, true, true,
        ],
        type: 'Socializing',
    },
    {
        name: TemplateName.T3NIGHTS11NIGHTS,
        days: [
            false, false, false, false, true, true, true,
            false, false, false, false, false, false, false,
        ],
        type: 'Socializing',
    },
    {
        name: TemplateName.T2NIGHTS12NIGHTS,
        days: [
            false, false, false, false, false, true, true,
            false, false, false, false, false, false, false,
        ],
        type: 'Socializing',
    },
    {
        name: TemplateName.TDOUBLEWEEK,
        days: [
            false, false, false, false, false, false, false,
            false, false, false, false, false, false, false,
            true, true, true, true, true, true, true,
            true, true, true, true, true, true, true,
        ],
        type: 'AlternatingResidence',
    },
    {
        name: TemplateName.TTENELEVEN,
        days: [
            false, false, false, false, false, false, false,
            false, false, false, true, true, true, true,
            true, true, true, true, true, true, true,
            false, false, false, false, false, false, false,
            false, false, false, false, true, true, true,
            true, true, true, true, true, true, true,
        ],
        type: 'AlternatingResidence',
    },
];



// WEBPACK FOOTER //
// ./src/constants/calendarTemplates.ts